import {
    Button,
    Container,
    Dialog,
    IconButton,
    Paper,
    Stack,
    Typography,
    TextField as MuiTextField,
    Box
  } from '@mui/material';
  import { Checkbox, FormProvider, SelectTag, Table, TextField } from '../../../../../components';
  import { useForm } from 'react-hook-form';
  import SearchIcon from '@mui/icons-material/Search';
  import { yupResolver } from '@hookform/resolvers/yup';
  import * as Yup from 'yup';

  import {
    getCurrentDateTime,
    getKeyPathValue,
    getISTDate,
    request,
    toast,
    calculateAge,
    dropdownFetch
  } from '../../../../../utils';
  import { useCallback, useEffect, useState } from 'react';
  import { useLocation } from 'react-router-dom';
  import { CustomButtonn } from '../../../../../components';
  import CloseIcon from '@mui/icons-material/Close';
  
  const initialPatientDataObj = {
    data: [],
    loading: false
  };

  const initialPatientQueryDataObj = {
    data: [],
    loading: false
  };



  const TABLE_COLUMNS = [
    { header: 'UHID No.', accessor: 'uhid' },
    { header: 'OP No.', accessor: 'op_no' },
    { header: 'Date', accessor: (row) => `${getCurrentDateTime('date', row?.date)}` },
    {
      header: 'Patient name',
      accessor: (row) => {
        const status = row.status;
        return (
          <span
            style={{
              color: status === 'inactive' ? 'red' : 'black'
            }}
          >
            {`${row?.name_suffix} ${row?.first_name} ${row?.last_name ? row?.last_name : ''}`}
          </span>
        );
      }
    },
    { header: 'Guardian', accessor: 'guardian_name' },
    { header: 'Mobile No.', accessor: 'address.mobile' },
    { header: 'Aadhar No.', accessor: 'address.aadhar' },
    { header: 'Doctor Name', accessor: 'consultant.name' },
    { header: 'Recd Amount', accessor: 'recd' },
    { header: 'Sponsor Name', accessor: 'sponsor.name' },
    { header: 'Address', accessor: 'address.address' },
    { header: 'Status', accessor: 'status', sx: { textTransform: 'uppercase' } }
  ];

  const QUERY_TABLE_COLUMNS = [
    { header: 'UHID No.', accessor: 'uhid' },
    { header: 'Date', accessor: (row) => `${getCurrentDateTime('date', row?.date)}` },
    {
      header: 'Patient name',
      accessor: (row) => {
        const status = row.status;
        return (
          <span
            style={{
              color: status === 'inactive' ? 'red' : 'black'
            }}
          >
            {`${row?.patient?.name}`}
          </span>
        );
      }
    },
    { header: 'Mobile No.', accessor:(row)=> row?.patient?.mobile },
    { header: 'Doctor Name', accessor: (row)=> row?.patient?.doctor },
    { header: 'Status', accessor: 'status', sx: { textTransform: 'uppercase' } }
  ];
  
  export const EchsReferral = () => {
    const { pathname } = useLocation();
    const lastPathSegment = pathname.split('/').pop();
    const pathParts = pathname.split('/');
    const organisation = pathParts[1];
    const [loading, setLoading] = useState(false);
    const [openQueryDialog, setOpenQueryDialog] = useState(false);
    const [openQueryListDialog,setOpenQueryListDialog] = useState(false)
    const [currentAction, setCurrentAction] = useState();
    const [selectedRecord, setSelectedRecord] = useState();
    const [input, setInput] = useState('');
    const [queryInput, setQueryInput] = useState('');
    const [isFiltered, setIsFiltered] = useState(false);
    const [patientDataObj, setPatientDataObj] = useState(initialPatientDataObj);
    const [patientDataQueryObj, setPatientDataQueryObj] = useState(initialPatientQueryDataObj);
    const user = JSON.parse(localStorage.getItem('user'));
    const [startDateInput, setStartDateInput] = useState('');
    const [endDateInput, setEndDateInput] = useState('');
    const [rankDropdown,setRankDropdown] = useState([])
    const [doctorDropdown, setDoctorDropdown] = useState([]);
  

    const { getValues } = useForm();
  
    const isEnabledDate =
      user && user.permissions ? user.permissions.some((permission) => permission.includes('DatePermission')) : false;
  
    const methods = useForm({
      resolver: yupResolver(
        Yup.object().shape({
      

        })
      ),
      defaultValues: {
       date: getISTDate(),
        time: new Date().toLocaleTimeString('en-US', { hour12: false }).slice(0, 5),
        referral_date :getISTDate(),

      },
      mode: 'all'
    });
    const { handleSubmit, watch, setValue, reset } = methods;
  
      const getRankDropdown = useCallback(async () => {
        const data = await dropdownFetch('rank-master');
        if (!selectedRecord) {
          const [defaultRankMaster] = data.filter(({ status }) => status === 'default');
          setValue('credit.rank', defaultRankMaster?._id);
        }
        setRankDropdown(data);
      }, [selectedRecord]);

      const getDoctorDropdown = useCallback(async () => {
        const data = await dropdownFetch('doctor');
        if (!selectedRecord && !getValues('consultant')) {
          const [defaultState] = data.filter(({ status }) => status === 'default');
          setValue('consultant', defaultState?._id);
          if (defaultState) {
            setValue('department', defaultState.qualification_details.department);
          }
        }
    
        setDoctorDropdown(data);
      }, [selectedRecord, getValues, setValue]);

      useEffect(()=>{
        getRankDropdown()
        getDoctorDropdown()
      },[getRankDropdown,getDoctorDropdown])
  
    const formSubmit = async (formValue) => {
      setLoading(true);
      let editFlag = false;
      if (selectedRecord && currentAction === 'edit') {
        editFlag = true;
      }
      const response = await request(editFlag ? '/echs-referral-update' : '/echs-referral-create', {
        method: editFlag ? 'PUT' : 'POST',
        params: editFlag ? selectedRecord._id : null,
        body: {
          ...formValue,
          createdBy: user.name,
          updatedBy: editFlag ? user.name : '',
          organisation,
        }
      });
      if (response?.success) {
        toast(`Successfully ${editFlag ? 'updated' : 'created'} ECHS Referral`, { variant: 'success' });
        setSelectedRecord(response?.data);
        setCurrentAction('');
      } else {
        toast(`Failed to ${editFlag ? 'update' : 'create'} ECHS Referral`, {
          variant: 'error'
        });
      }
      setLoading(false);
    };
  

    const handleCancelRecord = async () => {
      setLoading(true);
      const response = await request('/echs-referral-cancel', {
        method: 'DELETE',
        params: selectedRecord._id
      });
      if (response?.success) {
        toast('Successfully Cancelled ECHS Referral', { variant: 'success' });
        setSelectedRecord();
      } else {
        toast('Failed to Cancelled ECHS Referral', { variant: 'error' });
      }
      setLoading(false);
    };
  
    const handleDeleteRecord = async () => {
      setLoading(true);
      const response = await request('/echs-referral-delete', {
        method: 'DELETE',
        params: selectedRecord._id
      });
      if (response?.success) {
        toast('Successfully deleted ECHS Referral', { variant: 'success' });
        setSelectedRecord();
      } else {
        toast('Failed to delete ECHS Referral', { variant: 'error' });
      }
      setLoading(false);
    };
  
    const handleQueryWindow = async () => {
      setOpenQueryListDialog(true);
      setPatientDataObj({ loading: true });
      try {
        const response = await request('/echs-referral-list', { method: 'GET' });
        if (response.success) {
          const sortedData = response.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
          const filteredData = sortedData.filter(
            (item) => item.status === 'active' || item.status === 'inactive' || item.status === 'default'
          );
          setPatientDataQueryObj({ loading: false, data: filteredData });
        } else {
          toast('Error in fetching data', { variant: 'error' });
          setPatientDataObj({ loading: false });
        }
      } catch (error) {
        console.error('Error fetching patient data:', error);
        toast('Error in fetching data', { variant: 'error' });
        setPatientDataQueryObj({ loading: false });
      }
    };


  useEffect(()=>{
    handlePatientSearch()
  },[queryInput])

    const handlePatientSearch = async () => {
      const lowercasedInput = queryInput.toLowerCase().trim();
      try {
        const query = {};
        if (lowercasedInput) {
          query.name = lowercasedInput;
        }
        const response = await request('/echs-referral-list', {
          method: 'GET',
          query: query
        });
        if (response.success) {
          const sortedData = response.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
          const filteredData = sortedData.filter(
            (item) => item.status === 'active' || item.status === 'inactive' || item.status === 'default'
          );
          setPatientDataQueryObj({ loading: false, data: filteredData });
        } else {
          toast('Error in fetching dataaaaa', { variant: 'error' });
        }
      } catch (error) {
        console.error('Error during search:', error);
        toast('Error during search', { variant: 'error' });
      }
    };

    const handleQueryChange =(e)=>{
     setQueryInput(e.target.value)
    }
  
    useEffect(() => {
      if (patientDataObj.data && patientDataObj.data.length > 0) {
        setIsFiltered(false);
      }
    }, [patientDataObj.data]);
  
    const handleUhidSearch = async () => {
      const lowercasedInput = input.toLowerCase().trim();
      try {
        const query = {};
        if (lowercasedInput) {
          query.name = lowercasedInput;
        }
        const response = await request('/patient-registeration-list', {
          method: 'GET',
          query: query
        });
        if (response.success) {
          const sortedData = response.patientData.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
          const filteredData = sortedData.filter(
            (item) => item.status === 'active' || item.status === 'inactive' || item.status === 'default'
          );
          setPatientDataObj({ loading: false, data: filteredData });
        } else {
          toast('Error in fetching dataaaaa', { variant: 'error' });
        }
      } catch (error) {
        console.error('Error during search:', error);
        toast('Error during search', { variant: 'error' });
      }
    };
  

    useEffect(() => {
      handleUhidSearch(input);
    }, [input]);
   

    const handlePatientData = async () => {
      setOpenQueryDialog(true);
      setPatientDataObj({ loading: true });
      try {
        const response = await request('/patient-registeration-list', { method: 'GET' });
        if (response.success) {
          const sortedData = response.patientData.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
          const filteredData = sortedData.filter(
            (item) => item.status === 'active' || item.status === 'inactive' || item.status === 'default'
          );
          setPatientDataObj({ loading: false, data: filteredData });
        } else {
          toast('Error in fetchingggggggg data', { variant: 'error' });
          setPatientDataObj({ loading: false });
        }
      } catch (error) {
        console.error('Error fetching patient data:', error);
        toast('Error in fetching data', { variant: 'error' });
        setPatientDataObj({ loading: false });
      }
    };


    const handleChange = (e) => {
      const newInput = e.target.value;
      setInput(newInput);
    };
    
    const handleStartChangeDate = (e) => {
      setStartDateInput(e.target.value);
    };
  
    const handleEndChangeDate = (e) => {
      setEndDateInput(e.target.value);
    };


    const handleSearchByDate = async () => {
      setPatientDataObj({ loading: true, data: [] });
      try {
        const query = {};
        if (startDateInput && endDateInput) {
          query.startDate = startDateInput;
          query.endDate = endDateInput;
        }
        const response = await request('/patient-registeration-list', {
          method: 'GET',
          query: query
        });
        if (response.success) {
          const sortedData = response.patientData.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
          const filteredData = sortedData.filter(
            (item) => item.status === 'active' || item.status === 'inactive' || item.status === 'default'
          );
          setPatientDataObj({ loading: false, data: filteredData });
        } else {
          toast('Error in fetching dataaaaa', { variant: 'error' });
        }
      } catch (error) {
        console.error('Error during search:', error);
        toast('Error during search', { variant: 'error' });
      }
    };

    return (
      <>
        <Paper
          sx={{
            p: 0,
            flex: 1,
            borderRadius: 0,
            boxShadow: 'none',
            width: '100%',
            height: 'auto'
          }}
        >
          <Container
            sx={{
              mt: 1,
              border: '0px solid',
              borderColor: 'grey.300',
              borderRadius: 1,
              width: '100%',
              boxSizing: 'border-box',
              minWidth: '100%'
            }}
          >
            <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
              <Stack
                direction="row"
                spacing={2}
                justifyContent="space-between"
                alignItems="center"
                sx={{
                  mb: 1,
                  borderBottom: '0px solid',
                  borderColor: 'grey.300'
                }}
              >
                <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
                  ECHS Referral
                </Typography>
                <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                  <CustomButtonn
                    id={`${lastPathSegment}Write`}
                    variant="contained"
                    disabled={['edit', 'new'].includes(currentAction)}
                    onClick={() => {
                      setSelectedRecord();
                      setCurrentAction('new');
                    }}
                  >
                    New
                  </CustomButtonn>
                  <CustomButtonn
                    id={`${lastPathSegment}Update`}
                    variant="contained"
                    disabled={['new', 'edit'].includes(currentAction) || !selectedRecord}
                    onClick={() => setCurrentAction('edit')}
                  >
                    Edit
                  </CustomButtonn>
                  <CustomButtonn
                    id={'Submit'}
                    type="submit"
                    variant="contained"
                    disabled={!['edit', 'new'].includes(currentAction) || loading}
                  >
                    Save
                  </CustomButtonn>
                  <CustomButtonn
                    id={'Cancel'}
                    variant="contained"
                    disabled={!selectedRecord || currentAction}
                    onClick={() => {
                      setCurrentAction();
                      handleCancelRecord();
                    }}
                  >
                    Cancel
                  </CustomButtonn>
                  <CustomButtonn
                    id={`isSuperAdmin`}
                    variant="contained"
                    disabled={!selectedRecord || ['new', 'edit'].includes(currentAction) || loading}
                    onClick={handleDeleteRecord}
                  >
                    Delete
                  </CustomButtonn>
                  <CustomButtonn
                    id={`${lastPathSegment}Read`}
                    variant="contained"
                    onClick={handleQueryWindow}
                    disabled={['new', 'edit'].includes(currentAction)}
                  >
                    Query
                  </CustomButtonn>
                  <CustomButtonn
                    id={`${lastPathSegment}Print`}
                    variant="contained"
                    onClick={() => {
                      window.open(`/print${pathname}?refId=${selectedRecord._id}`, '_blank');
                    }}
                    disabled={!selectedRecord || currentAction}
                  >
                    Print
                  </CustomButtonn>
                  <CustomButtonn
                    id={`${lastPathSegment}Print`}
                    variant="contained"
                    onClick={() => {
                      window.open(`/print${pathname}/invoice-print?refId=${selectedRecord._id}`, '_blank');
                    }}
                    disabled={!selectedRecord || currentAction}
                  >
                    invoice Print
                  </CustomButtonn>
                  <CustomButtonn
                    id={'Exit'}
                    variant="contained"
                    onClick={() => {
                      setCurrentAction('');
                      setSelectedRecord(null);
                      window.location.reload();
                    }}
                  >
                    Exit
                  </CustomButtonn>
                </Stack>
              </Stack>
              <Box
                sx={{
                  border: '0px solid gray',
                  padding: 2,
                  borderRadius: '8px',
                  width: '100%',
                  boxShadow: '0px 2px 10px #0099ff'
                }}
              >
                <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                  <Stack sx={{ flex: 1 / 3 }} spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.35, fontWeight: 700, fontSize: '1.4rem' }}>UHID</Typography>
                    <TextField disabled sx={{ flex: 0.8 }} name="uhid" placeholder="UHID" />
                    <Button
                      disabled={!['new', 'edit'].includes(currentAction)}
                      sx={{
                        flex: 0.1,
                        minWidth: 0,
                        p: 0.25,
                        height: '100%',
                        position: 'relative'
                      }}
                      variant="contained"
                      onClick={handlePatientData}
                    >
                      <SearchIcon />
                    </Button>
                  </Stack>
                  <Stack sx={{ flex: 1 / 3 }} spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Date/Time</Typography>
                    <TextField disabled={!isEnabledDate || !['new', 'edit'].includes(currentAction)} sx={{ flex: 0.4 }} name="date" type="date" />
                    <TextField
                      sx={{ flex: 0.4 }}
                      name="time"
                      type="time"
                      disabled={!isEnabledDate || !['new', 'edit'].includes(currentAction)}
                    />
                  </Stack>
                  <Stack sx={{ flex: 1 / 3 }} spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Patient Name</Typography>
                    <TextField
                      sx={{ flex: 0.8 }}
                      name="patient_name"
                      placeholder="Patient Name"
                      disabled
                    />
                  </Stack>
                </Stack>
                <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                  <Stack sx={{ flex: 1 / 3 }} spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Reg. Date</Typography>
                    <TextField
                      disabled
                      sx={{ flex: 0.8 }}
                      name="reg_date"
                      type="date"
                    />
                  </Stack>
                  <Stack sx={{ flex: 1 / 3 }} spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Age/Gender</Typography>
                    <TextField
                      disabled
                      sx={{
                        flex: 0.4
                      }}
                      name="age"
                      placeholder="Age"
                    />
                    <TextField
                      disabled
                      sx={{
                        flex: 0.4
                      }}
                      name="gender"
                      placeholder="Gender"
                    />
                  </Stack>
                  <Stack sx={{ flex: 1 / 3 }} spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Mobile No.</Typography>
                    <TextField
                      disabled
                      sx={{ flex: 0.8 }}
                      name="mobile_no"
                      placeholder="Mobile No"
                    />
                  </Stack>
                </Stack>
                <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                  <Stack sx={{ flex: 1 / 3 }} spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Doctor Name</Typography>
                    <TextField
                      disabled
                      sx={{ flex: 0.8 }}
                      name="doctor_name"
                      placeholder="Doctor name"
                    />
                  </Stack>
                  <Stack sx={{ flex: 1/1.5 }} spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.19, fontWeight: 700, fontSize: '1.4rem' }}>Address</Typography>
                    <TextField
                      disabled
                      sx={{
                        flex: 1,
                      }}
                      name="patient_address"
                      placeholder="Address"
                    />
                  </Stack>
                </Stack>
                <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                  <Stack sx={{ flex: 1 / 3 }} direction="row" alignItems="center" spacing={0.5}>
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Referral Date</Typography>
                    <TextField
                      disabled={!['new', 'edit'].includes(currentAction)}
                      sx={{ flex: 0.8, fontWeight: 700, fontSize: '1.4rem'}}
                      name="referral_date"
                      type="date"
                    />
                  </Stack>
                  <Stack sx={{ flex: 1 / 3 }} direction="row" alignItems="center" spacing={0.5}>
                    <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Valid From</Typography>
                    <TextField
                      disabled={!['new', 'edit'].includes(currentAction)}
                      sx={{ flex: 0.8 }}
                      name="valid_from"
                      type="date"
                    />
                  </Stack>
                  <Stack sx={{ flex: 1 / 3 }} direction="row" alignItems="center" spacing={0.5}>
                    <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Valid To</Typography>
                    <TextField
                      disabled={!['new', 'edit'].includes(currentAction)}
                      sx={{ flex: 0.8 }}
                      name="valid_to"
                      type="date"
                    />
                  </Stack>
                </Stack>
                <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                  <Stack spacing={0.4} sx={{ flex: 1 / 3 }} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Service No.</Typography>
                    <TextField
                      disabled
                      sx={{ flex: 0.8 }}
                      name="service_no"
                      placeholder="Service No."
                    />
                  </Stack>
                  <Stack spacing={0.4} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                    <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>ECHS Reg No.</Typography>
                    <TextField
                      disabled
                      sx={{
                        flex: 0.8,
                      }}
                      name="echs_reg_no"
                      placeholder="ECHS Reg No"
                      onChange={({ target: { row } }) => {
                        setValue('department', row.qualification_details.department);
                      }}
                      onKeyDown={(e) => {
                        if (e.key === 'Tab') {
                          e.target.value = '';
                        }
                      }}
                    />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                    <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>ECHS Ref Serial No</Typography>
                    <TextField
                      disabled={!['new',"edit"].includes(currentAction)}
                      sx={{ flex: 0.8 }}
                      name="echs_ref_serial_no"
                      placeholder="ECHS Ref Serial  No."
                    />
                  </Stack>
                </Stack>
                <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                  <Stack spacing={0.4} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Employee Id No.</Typography>
                    <TextField
                      disabled
                      sx={{ flex: 0.8 }}
                      name="emp_id"
                      placeholder="Employee ID No."
                    />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                    <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Date Of Membership</Typography>
                    <TextField
                      disabled={!['new', 'edit'].includes(currentAction)}
                      sx={{ flex: 0.8 }}
                      name="date_of_membership"
                      type="date"
                    />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                    <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Relationship With ESM</Typography>
                    <TextField
                      disabled
                      sx={{ flex: 0.8 }}
                      name="rel_esm"
                      placeholder="Relationship With ESM"
                    />
                  </Stack>
                </Stack>

                <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                  <Stack spacing={0.4} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Name Of ESM</Typography>
                    <TextField
                      disabled={!['new', 'edit'].includes(currentAction)}
                      sx={{ flex: 0.8 }}
                      name="esm_name"
                      placeholder="Name Of ESM"
                    />
                  </Stack>
                  <Stack spacing={0.4} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                    <Typography sx={{ flex: 0.41, fontWeight: 700, fontSize: '1.4rem' }}>Ref Doctor Name</Typography>
                    <SelectTag
                      disabled={!['new', 'edit'].includes(currentAction)}
                      formControlSX={{ flex: 0.8 }}
                      name="ref_doctor"
                      placeholder ="Ref Doctor Name"
                      menus={doctorDropdown}
                    />
                  </Stack>
                  <Stack spacing={0.4} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                    <Typography sx={{ flex: 0.41, fontWeight: 700, fontSize: '1.4rem' }}>Rank</Typography>
                    <SelectTag
                      disabled
                      formControlSX={{ flex: 0.8 }}
                      name="rank"
                      placeholder="Select Rank"
                      menus={rankDropdown.map((data) => ({ ...data, name: data.rankname }))}
                    />
                  </Stack>
                </Stack>

                <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                <Stack sx={{ flex: 1 / 3 }} alignItems="center" direction="row" spacing={0.5}>
                    <Typography sx={{ flex: 0.27, fontWeight: 700, fontSize: '1.4rem' }}>Claim Id</Typography>
                    <TextField
                      disabled={!['new', 'edit'].includes(currentAction)}
                      sx={{ flex: 0.7 }}
                      name="claim_id"
                      placeholder="Claim ID"
                    />
                  </Stack>
                  </Stack>
                <Stack direction="row" spacing={2} alignItems="center" sx={{marginTop:"3%"}}>
                    <Typography sx={{ flex: 0.25, fontSize: '1.4rem', fontWeight: 700 }}>Provisional Diagnosis</Typography>
                    <Typography sx={{fontSize: '1.4rem', fontWeight: 700 }}>Admission</Typography>
                    <Checkbox disabled={!['new', 'edit'].includes(currentAction)} name="admission" fontSize={18} />
                    <Typography sx={{fontSize: '1.4rem', fontWeight: 700 }}>Investigation</Typography>
                    <Checkbox disabled={!['new', 'edit'].includes(currentAction)} name="investigation" fontSize={18} />
                    <Typography sx={{fontSize: '1.4rem', fontWeight: 700 }}>Consultation</Typography>
                    <Checkbox disabled={!['new', 'edit'].includes(currentAction)} name="consultation" fontSize={18} />
                </Stack>

              </Box>
              {/* </Grid> */}
            </FormProvider>
          </Container>
        </Paper>


        <Dialog
        open={openQueryDialog}
        onClose={() => {
          setOpenQueryDialog(false);
          setStartDateInput('');
          setEndDateInput('');
        }}
        PaperProps={{ sx: { width: '80%', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <Stack
          padding={0}
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          borderBottom="1px solid"
          borderColor="grey.300"
        >
          <Typography variant="h4" fontWeight="bold">
            Patient Registeration Query Window
          </Typography>
          <IconButton
            onClick={() => {
              setOpenQueryDialog(false);
              setStartDateInput('');
              setEndDateInput('');
            }}
          >
            <CloseIcon color="error" fontSize="large" />
          </IconButton>
        </Stack>
        <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 0 }}>
          <MuiTextField
            sx={{
              width: '100%',
              '& .MuiOutlinedInput-root': {
                padding: '0',
                fontSize: '14px'
              },
              '& .MuiOutlinedInput-input': {
                padding: '8px 10px'
                // fontSize: '14px'
              },
              '& .MuiInputLabel-root': {
                fontSize: '1.2rem' // Adjust label font size
              }
            }}
            label="Search Patient"
            placeholder="Search Patient"
            variant="outlined"
            value={input}
            onChange={handleChange}
          />
        </Stack>
        <Stack
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="center"
          sx={{
            mt: 1,
            mb: 1,
            width: '60%',
            gap: 2,
            justifyContent: 'space-between'
          }}
        >
          <Typography
            sx={{
              flex: 1,
              fontWeight: 700,
              fontSize: '1.4rem',
              textAlign: 'center' // Centers the label text
            }}
          >
            From Date
          </Typography>

          <MuiTextField
            sx={{
              flex: 2, // This ensures the input takes more space
              '& .MuiOutlinedInput-root': {
                padding: '0',
                fontSize: '14px'
              },
              '& .MuiOutlinedInput-input': {
                padding: '8px 14px'
              },
              '& .MuiInputLabel-root': {
                fontSize: '1.2rem' // Adjust label font size
              }
            }}
            variant="outlined"
            name="from_date"
            type="date"
            onChange={handleStartChangeDate}
            value={startDateInput}
          />

          <Typography
            sx={{
              flex: 1,
              fontWeight: 700,
              fontSize: '1.4rem',
              textAlign: 'center' // Centers the label text
            }}
          >
            To Date
          </Typography>

          <MuiTextField
            sx={{
              flex: 2, // This ensures the input takes more space
              '& .MuiOutlinedInput-root': {
                padding: '0',
                fontSize: '14px'
              },
              '& .MuiOutlinedInput-input': {
                padding: '8px 14px'
              },
              '& .MuiInputLabel-root': {
                fontSize: '1.2rem' // Adjust label font size
              }
            }}
            name="to_date"
            variant="outlined"
            type="date"
            onChange={handleEndChangeDate}
            value={endDateInput}
          />
          <Button variant="contained" disabled={!startDateInput || !endDateInput} onClick={handleSearchByDate}>
            Search
          </Button>
        </Stack>
        <Table
          sx={{ mt: 0.5 }}
          columns={TABLE_COLUMNS}
          data={patientDataObj.data || []}
          loading={patientDataObj.loading}
          onRowClick={(row) => {
            setValue('uhid',row?.uhid)
            setValue('patient_name',`${row?.name_suffix} ${row?.first_name} ${row?.last_name}`)
            const formattedRegDate = new Date(row.date).toISOString().split('T')[0]
            setValue('reg_date', formattedRegDate);
            setValue('age', calculateAge(row?.dob))
            setValue('gender',row?.gender)
            setValue('mobile_no',row?.address?.mobile)
            setValue('doctor_name',row?.consultant?.name)
            setValue('patient_address', row?.address?.address)
            setValue('service_no',row?.credit?.service_no)
            setValue('echs_reg_no',row?.credit?.reg_number)
            setValue('emp_id',row?.credit?.emp_id)
            setValue('rel_esm',row?.credit?.rel_esm)
            setValue('rank', row?.credit?.rank?._id)
            setOpenQueryDialog(false);
          }}
        />
      </Dialog>





      <Dialog
        open={openQueryListDialog}
        onClose={() => {
          setOpenQueryListDialog(false);
        }}
        PaperProps={{ sx: { width: '80%', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <Stack
          padding={0}
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          borderBottom="1px solid"
          borderColor="grey.300"
        >
          <Typography variant="h4" fontWeight="bold">
           ECHS Referral Query Window
          </Typography>
          <IconButton
            onClick={() => {
              setOpenQueryListDialog(false);
            }}
          >
            <CloseIcon color="error" fontSize="large" />
          </IconButton>
        </Stack>
        <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 0 }}>
          <MuiTextField
            sx={{
              width: '100%',
              '& .MuiOutlinedInput-root': {
                padding: '0',
                fontSize: '14px'
              },
              '& .MuiOutlinedInput-input': {
                padding: '8px 10px'
                // fontSize: '14px'
              },
              '& .MuiInputLabel-root': {
                fontSize: '1.2rem' // Adjust label font size
              }
            }}
            label="Search Patient"
            placeholder="Search Patient"
            variant="outlined"
            value={queryInput}
            onChange={handleQueryChange}
          />
        </Stack>
        <Table
          sx={{ mt: 0.5 }}
          columns={QUERY_TABLE_COLUMNS}
          data={patientDataQueryObj.data || []}
          loading={patientDataObj.loading}
          onRowClick={(row) => {
            setSelectedRecord(row)
            setValue('uhid',row?.uhid)
            setValue('patient_name',`${row?.patient?.name}`)
            const formattedRegDate = new Date(row.date).toISOString().split('T')[0]
            setValue('reg_date', formattedRegDate);
            const formattedValidFromDate = new Date(row.valid_from).toISOString().split('T')[0]
            setValue('valid_from', formattedValidFromDate);
            const formattedValidToDate = new Date(row.valid_to).toISOString().split('T')[0]
            setValue('valid_to', formattedValidToDate);
            const formattedReferralDate = new Date(row.referral_date).toISOString().split('T')[0]
            setValue('referral_date', formattedReferralDate);
            const formattedmembershipdate = new Date(row.date_of_membership).toISOString().split('T')[0]
            setValue('date_of_membership', formattedmembershipdate);
            setValue('age', calculateAge(row?.patient?.dob))
            setValue('gender',row?.patient?.gender)
            setValue('ref_doctor',row?.ref_doctor)
            setValue('esm_name',row?.esm_name)
            setValue('echs_ref_serial_no',row?.echs_ref_serial_no)
            setValue('claim_id',row?.claim_id)
            setValue('mobile_no',row?.patient?.mobile)
            setValue('doctor_name',row?.patient?.doctor)
            setValue('patient_address', row?.patient?.address)
            setValue('service_no',row?.patient?.credit?.service_no)
            setValue('echs_reg_no',row?.patient?.credit?.reg_number)
            setValue('emp_id',row?.patient?.credit?.emp_id)
            setValue('rel_esm',row?.patient?.credit?.rel_esm)
            setValue('rank', row?.patient?.credit?.rank)
            setValue('admission', row?.admission === "true");
            setValue('investigation', row?.investigation === "true");
            setValue('consultation', row?.consultation === "true");            
            setOpenQueryListDialog(false);
          }}
        />
      </Dialog>
      </>
    );
  };
  